/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit CreditCardDiscover/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function CreditCardDiscover({
  children,
  viewPath = "/DesignSystem/Svgs/CreditCardDiscover",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 53,
  height = 34,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#fff",
  fill3 = "#ee7623",
  fill4 = "#231f20"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="CreditCardDiscover.Svg"
  data-view-path={viewPath}
 viewBox="0 0 53 34"
 fillRule="evenodd"
 clipRule="evenodd"
 strokeLinejoin="round"
 strokeMiterlimit={2}
 style={{'--as-1-1X82jp': alignSelf,'--mt-2-1X82jp': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1X82jp': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1X82jp': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1X82jp': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1X82jp': opacity,'--w-10-1X82jp': typeof width === 'number' ? `${width}px` : width,'--h-11-1X82jp': typeof height === 'number' ? `${height}px` : height,'--a-7-1X82jp': isAnimated ? animation : "none",'--sd-8-1X82jp': isAnimated ? strokeDashoffset : 0,'--sd-9-1X82jp': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="CreditCardDiscover.SvgPath"
  data-view-path={viewPath}
 d="M-211.5-21.2h288v74h-288z"
 style={{'--f-12-1X82jp': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:1"
  data-view-path={viewPath}
 d="M.2.1h52.2v33.2H.2z"
 style={{'--f-12-1X82jp': fill}}
 className={`views-block ${styles.SvgPath1}`}
/>
<g
  data-testid="CreditCardDiscover.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#a)"
 className="views-block"
>
<path
  data-testid="CreditCardDiscover.SvgPath:2"
  data-view-path={viewPath}
 d="M52.2 18.6S37.9 28.7 11.8 33.2h40.4V18.6z"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill3}}
 className={`views-block ${styles.SvgPath2}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:3"
  data-view-path={viewPath}
 d="M52.6 0H0v33.6h52.6V0zm-.4.3v32.8H.4V.3h51.8"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath3}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:4"
  data-view-path={viewPath}
 d="M4.6 10.2H2.5v7.6h2.2c1.2 0 2-.3 2.7-.9.9-.7 1.4-1.8 1.4-2.9-.1-2.2-1.8-3.8-4.2-3.8m1.8 5.7c-.5.4-1.1.6-2 .6H4v-5h.4c1 0 1.5.2 2 .6.5.5.8 1.2.8 1.9 0 .8-.3 1.5-.8 1.9"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath4}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:5"
  data-view-path={viewPath}
 d="M9.4 10.2h1.5v7.6H9.4z"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath5}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:6"
  data-view-path={viewPath}
 d="M14.5 13.2c-.9-.3-1.2-.5-1.2-1s.5-.8 1.1-.8c.4 0 .8.2 1.2.6l.8-1c-.6-.6-1.4-.8-2.2-.8-1.3 0-2.4.9-2.4 2.2 0 1 .5 1.6 1.9 2.1.6.2.9.3 1 .4.3.2.4.5.4.8 0 .6-.5 1.1-1.2 1.1s-1.3-.4-1.6-1l-1 .9c.7 1 1.5 1.4 2.6 1.4 1.5 0 2.6-1 2.6-2.5.2-1.3-.3-1.8-2-2.4M17.2 14c0 2.2 1.8 4 4 4 .6 0 1.2-.1 1.9-.4v-1.8c-.6.6-1.1.8-1.8.8-1.5 0-2.6-1.1-2.6-2.6s1.1-2.6 2.5-2.6c.7 0 1.2.3 1.9.9v-1.7c-.7-.3-1.2-.5-1.8-.5-2.3 0-4.1 1.7-4.1 3.9M34.8 15.3l-2-5.1h-1.6l3.2 7.8h.8l3.3-7.8h-1.6l-2.1 5.1zM39.1 17.8h4.2v-1.2h-2.7v-2.1h2.6v-1.3h-2.6v-1.7h2.7v-1.3h-4.2v7.6zM49.2 12.5c0-1.4-1-2.2-2.7-2.2h-2.2v7.5h1.5v-3h.2l2.1 3.1h1.8l-2.4-3.2c1.1-.3 1.7-1.1 1.7-2.2m-3 1.2h-.4v-2.3h.5c.9 0 1.4.4 1.4 1.1 0 .8-.5 1.2-1.5 1.2"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath6}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:7"
  data-view-path={viewPath}
 d="M31.6 14c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4 4 1.8 4 4"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill3}}
 className={`views-block ${styles.SvgPath7}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:8"
  data-view-path={viewPath}
 d="M50 10.4c0-.1-.1-.2-.3-.2h-.2v.6h.2v-.3l.2.3h.2l-.2-.3c.1 0 .1 0 .1-.1m-.3.1v-.2c.1 0 .1 0 .1.1 0 0 0 .1-.1.1"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath8}`}
/>
<path
  data-testid="CreditCardDiscover.SvgPath:9"
  data-view-path={viewPath}
 d="M49.8 9.9c-.3 0-.6.3-.6.6s.3.6.6.6.6-.3.6-.6-.3-.6-.6-.6m0 1.1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5c-.1.3-.3.5-.5.5"
 fillRule="nonzero"
 style={{'--f-12-1X82jp': fill4}}
 className={`views-block ${styles.SvgPath9}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}